module.exports = __webpack_public_path__ + "img/DateTime.6544687a.svg";